import axios from 'axios';
import { message } from 'antd';

const baseUrl = (window as any).GLOBAL_CARRENTAL_API_PREFIX;

const service = axios.create({
	baseURL: `${baseUrl}/ota`,
	timeout: 300000,
	headers: {
		'Content-Type': 'application/json',
	},
});

service.interceptors.request.use(
	(config: any) => {
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

service.interceptors.response.use(
	(response: any) => {
		// if (response.config.url?.includes('export_operate_log') || response.config.url?.includes('export_order_log')) {
		//     return response.data;
		// }
		// if (response.data.code === 401) {
		//     window.location = response.data.redirectUrl;
		// } else if (response.data.code !== 200) {
		//     return Promise.reject(response.data)
		// } else if (response.data.code === 200) {
		//     return response.data.data;
		// }
		const { errno, errmsg, data } = response.data;

		if (process.env.NODE_ENV !== 'development' && errno === 403) {
			window.location = data.redirectUrl;
			message.error('登录超时，请重新登录');
			return;
		}

		if (errno !== 0) {
			message.error(response.data.errmsg);
			return Promise.reject(response.data);
		}
		return response.data;
	},
	error => {
		return Promise.reject(error);
	}
);

export default service;
